<template>
    <Breadcrumbs main="Ecommerce" title="Cart" />
    <div class="container-fluid">
        <div class="row">
            <productCart />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const productCart = defineAsyncComponent(() => import("@/components/theme/ecommerce/cart/productCart.vue"))
</script>